import { types } from "./types";

// All action creators accept a `meta` object so a caller can pass an
// `onSuccess` / `onError` callback (toast etc.) without coupling sagas
// to UI concerns.

export const getTeams = (meta = {}) => ({
  type: types.GET_TEAMS_REQUEST,
  meta,
});

export const createTeam = ({ name, color = "" }, meta = {}) => ({
  type: types.CREATE_TEAM_REQUEST,
  payload: { name, color },
  meta,
});

export const updateTeam = (id, { name, color }, meta = {}) => ({
  type: types.UPDATE_TEAM_REQUEST,
  payload: { id, name, color },
  meta,
});

export const archiveTeam = (id, meta = {}) => ({
  type: types.ARCHIVE_TEAM_REQUEST,
  payload: { id },
  meta,
});

export const assignUserTeam = (userId, team, meta = {}) => ({
  type: types.ASSIGN_USER_TEAM_REQUEST,
  payload: { userId, team },
  meta,
});
